(function () {
	// INIT lightbox if not exists
	if (!window.Lightbox) {
		const overlay = document.createElement('div');
		overlay.className = 'lightbox-overlay';
		overlay.innerHTML = `
			<button class="close">×</button>
			<button class="prev"><</button>
			<img />
			<button class="next">></button>
		`;

		document.body.appendChild(overlay);

		const imgEl = overlay.querySelector('img');
		const prevBtn = overlay.querySelector('.prev');
		const nextBtn = overlay.querySelector('.next');
		const closeBtn = overlay.querySelector('.close');

		let images = [];
		let current = 0;
		let scrollY = 0;

		function update() {
			imgEl.src = images[current].url;
			imgEl.alt = images[current].alt || '';
		}

		function updateControls() {
			const hasMultiple = images.length > 1;

			prevBtn.classList.toggle('is-hidden', !hasMultiple);
			nextBtn.classList.toggle('is-hidden', !hasMultiple);
		}

		function open({ images: imgs, startIndex = 0 }) {
			images = imgs;
			current = startIndex;

			update();
			updateControls();

			// save scroll position
			scrollY = window.scrollY;

			// lock scroll without losing position
			document.body.style.position = 'fixed';
			document.body.style.top = `-${scrollY}px`;
			document.body.style.left = '0';
			document.body.style.right = '0';
			document.body.style.width = '100%';

			overlay.classList.add('is-open');
		}

		function close() {
			overlay.classList.remove('is-open');

			// restore body
			document.body.style.position = '';
			document.body.style.top = '';
			document.body.style.left = '';
			document.body.style.right = '';
			document.body.style.width = '';

			// restore scroll position
			window.scrollTo(0, scrollY);

			document.dispatchEvent(
				new CustomEvent('lightboxClosed', {
					detail: { currentIndex: current },
				}),
			);
		}
		prevBtn.addEventListener('click', (e) => {
			e.stopPropagation();
			if (images.length <= 1) return;

			current = (current - 1 + images.length) % images.length;
			update();
		});

		nextBtn.addEventListener('click', (e) => {
			e.stopPropagation();
			if (images.length <= 1) return;

			current = (current + 1) % images.length;
			update();
		});

		closeBtn.addEventListener('click', close);

		overlay.addEventListener('click', (e) => {
			if (e.target === overlay) close();
		});

		document.addEventListener('keydown', (e) => {
			if (!overlay.classList.contains('is-open')) return;

			if (e.key === 'Escape') close();

			if (images.length > 1) {
				if (e.key === 'ArrowRight') nextBtn.click();
				if (e.key === 'ArrowLeft') prevBtn.click();
			}
		});

		window.Lightbox = { open };
	}

	// INIT gallery triggers for all blocks
	document.addEventListener('DOMContentLoaded', () => {
		const galleries = document.querySelectorAll('.gallery-lightbox');

		galleries.forEach((block) => {
			if (block.closest('.gallery-lightbox-group')) {
				return;
			}

			const imgs = block.querySelectorAll('img');
			const data = JSON.parse(
				decodeURIComponent(block.dataset.images) || '[]',
			);
			const morePixStartIndex = block.dataset.previewCount;

			imgs.forEach((img, index) => {
				img.addEventListener('click', () => {
					window.Lightbox.open({
						images: data,
						startIndex: index,
					});
				});
			});
		});
	});

	// function resizeJustifiedGallery() {
	// 	const getGapInPx = (remValue = 2) => {
	// 		const rootFontSize = parseFloat(
	// 			getComputedStyle(document.documentElement).fontSize,
	// 		);

	// 		return remValue * rootFontSize;
	// 	};

	// 	const galleries = document.querySelectorAll('.gallery-lightbox');
	// 	galleries.forEach((block) => {
	// 		const imgs = block.querySelectorAll('img');

	// 		const gap = getGapInPx(2);

	// 		const containerWidth = block.clientWidth;
	// 		const totalGapWidth = gap * (imgs.length - 1);

	// 		// calculate total aspect ratio
	// 		let totalAspectRatio = 0;

	// 		imgs.forEach((img) => {
	// 			const aspectRatio = img.naturalWidth / img.naturalHeight;
	// 			totalAspectRatio += aspectRatio;
	// 		});

	// 		// largest possible shared height
	// 		const targetHeight =
	// 			(containerWidth - totalGapWidth) / totalAspectRatio;

	// 		imgs.forEach((img) => {
	// 			const aspectRatio = img.naturalWidth / img.naturalHeight;

	// 			img.style.height = `${targetHeight}px`;
	// 			img.style.width = `${targetHeight * aspectRatio}px`;
	// 		});
	// 		block.style.height = targetHeight + 'px';
	// 	});
	// }

	//window.addEventListener('load', resizeJustifiedGallery);
	//window.addEventListener('resize', resizeJustifiedGallery);

	function resizeJustifiedGallery() {
		const MOBILE_MAX = 500;
		const CONTENT_MAX = 1279;

		const getGapInPx = (remValue = 2) => {
			const rootFontSize = parseFloat(
				getComputedStyle(document.documentElement).fontSize,
			);

			return remValue * rootFontSize;
		};

		const galleries = document.querySelectorAll('.gallery-lightbox');

		galleries.forEach((block) => {
			if (!block.classList.contains('full-width')) {
				return;
			}
			const containerWidth = block.clientWidth;

			if (containerWidth <= MOBILE_MAX) {
				return;
			}

			if (containerWidth <= CONTENT_MAX) {
				const imgs = block.querySelectorAll('img');
				const gap = getGapInPx(2);
				const containerWidth = block.clientWidth;
				const totalGapWidth = gap * (imgs.length - 1);
				// calculate total aspect ratio
				let totalAspectRatio = 0;
				imgs.forEach((img) => {
					const aspectRatio = img.naturalWidth / img.naturalHeight;
					totalAspectRatio += aspectRatio;
				});
				// largest possible shared height
				const targetHeight =
					(containerWidth - totalGapWidth) / totalAspectRatio;
				imgs.forEach((img) => {
					const aspectRatio = img.naturalWidth / img.naturalHeight;
					img.style.height = `${targetHeight}px`;
					img.style.width = `${targetHeight * aspectRatio}px`;
				});

				block.style.height = targetHeight + 'px';
			}
		});
	}

	// run once on load
	window.addEventListener('load', resizeJustifiedGallery);
	window.addEventListener('resize', resizeJustifiedGallery);

	// throttle resize for performance
	// let resizeTimeout;

	// window.addEventListener('resize', () => {
	// 	clearTimeout(resizeTimeout);
	// 	resizeTimeout = setTimeout(resizeJustifiedGallery, 100);
	// });
})();
